<template>
  <div class="container-fluid px-4">
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col-8">
            <h2 class="h2 e-text-red">Ships Performance Indicator</h2>
          </div>
        </div>
        <div class="row mb-2 justify-content-sm-between">
          <div class="col-auto">
            <nav class="navbar navbar-expand-lg mt-2" id="ModelNav">
              <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
                      aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <router-link
                      class="nav-link" :to="{ name: 'ShipsPiAccidentIncident' }">
                      <span style="height: 100%">ACCIDENT/INCIDENT</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link" :to="{ name: 'ShipsPiPSC' }">
                      <span>PSC INSPECTION</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link" :to="{ name: 'ShipsPiWorkingEnvironment' }">
                      <span>WORKING ENVIRONMENT</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link" :to="{ name: 'ShipsPiRightship' }">
                      <span>RIGHTSHIP INSPECTION</span>
                    </router-link>
                  </li>
                </ul>
              </div>

            </nav>
          </div>
        </div>
        <hr class="border border-secondary border-2 m-0 p-0" style="z-index: -1; opacity: 0.4; margin-top: -11px !important; top: 50px">

      </div>
    </div>

    <router-view :key="$route.params.feature"></router-view>
  </div>
</template>

<style scoped>
#ModelNav {
  padding: 0;

  li > a {
    padding: .5rem 2rem;
    color: #435464;
    height: 100%;
    text-align: center;
  }

  li:hover a {
    border-bottom: 4px solid #d3313c;
    color: #d3313c;
  }

  .nav-link span {
    font-size: 16px;
  }
}

.router-link-active {
  border-bottom: 4px solid #d3313c;
  color: #d3313c;
  font-weight: bold;

  * {
    color: #d3313c;
  }
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ShipsPI',
  methods : {
    ...mapActions([
      'getFleetListKeys',
      'getMedicalTypeKeys',
      'getMedicalSeverityKeys',
      'getVesselsWithOnboardCrewsKeys',
    ]),
  },
  computed: {
    ...mapGetters([
      'fleetKeys',
      'medicalTypeKeys',
      'medicalSeverityKeys',
      'vesselsWithOnboardCrewsInCms',
    ]),
  },
  async created() {
    await this.getFleetListKeys()
    await this.getMedicalTypeKeys()
    await this.getMedicalSeverityKeys()

    localStorage.setItem('fleetKeys', JSON.stringify(this.fleetKeys));
    localStorage.setItem('medicalTypeKeys', JSON.stringify(this.medicalTypeKeys));
    localStorage.setItem('medicalSeverityKeys', JSON.stringify(this.medicalSeverityKeys));
  },
}


</script>
